import { map } from 'rxjs/operators';
import { IClientApiDependencySegment, IApiLpSymbol } from '@cbridge-packages/api';
import { IClientLp } from '@cbridge-packages/lp-client';

export interface IUnmappedSymbolsQueryParams {
  limit: number;
  skip: number;
  search?: string;
  isLastPage?: boolean;
}

interface IUnmappedSymbolsResponse extends IUnmappedSymbolsQueryParams {
  lpSymbols: IApiLpSymbol[];
}

export const fetchUnmappedSymbolsLp = (
  lpId: IClientLp['lpId'],
  params: IUnmappedSymbolsQueryParams,
  dependencies: IClientApiDependencySegment,
) => {
  const { limit, skip, search } = params;
  return dependencies.api.getLpSymbolList({
    lpId,
    limit,
    skip,
    search,
    onlyUnmapped: true,
  }).pipe(
    map(({ lpSymbols }): IUnmappedSymbolsResponse => {
      const isLastPage = lpSymbols.length < limit;
      const nextOffset = skip + limit;

      return {
        limit, skip: nextOffset, search, lpSymbols, isLastPage,
      };
    }),
  );
};
